/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsurancePeriod } from './insurancePeriod';

/**
 * Abstract base class for all products at level two. Middle level in product hierarchy.  Defines a product for a concrete insurance sector.   (bipro-produktmodell::Produkt)
 */
export interface PreviousProductBase {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  insurancePeriod?: InsurancePeriod;
}
